module.exports = __webpack_public_path__ + "be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/be.svg
// module id = 697
// module chunks = 0